import SliderWidget from '../SliderWidget/SliderWidget.js';
import './RangeWidget.css';

class RangeWidget extends SliderWidget {
    constructor(container, options = { mode: 'integer'}){
        super(container, options);
        this.options.mode = this.options.mode || 'integer';
        if(!this._container.classList.contains('range-widget')) {
            this._container.classList.add('range-widget');
            const html = `<div class="range-widget-content">
                <input type="text" value="" />
                <i>-</i>
                <input type="text" value="" />
            </div>`;
            this._bar.insertAdjacentHTML('beforebegin', html);
            this._leftInput = this._container.querySelector('.range-widget-content input:first-child');
            this._rightInput = this._container.querySelector('.range-widget-content input:last-child');
            this._handleLeftInput = this._handleLeftInput.bind(this);
            this._handleRightInput = this._handleRightInput.bind(this);
            this._handleRange = this._handleRange.bind(this);
            this._leftInput.addEventListener('change', this._handleLeftInput);
            this._leftInput.addEventListener('focus', e => this._leftInput.select());
            this._rightInput.addEventListener('change', this._handleRightInput);
            this._rightInput.addEventListener('focus', e => this._rightInput.select());
            this.addEventListener('change', this._handleRange);
            this.values = [this.options.min, this.options.max];
        }
    }    
    _handleLeftInput(e){
        const lo = this.options.mode === 'integer' ? parseInt(this._leftInput.value, 10) : parseFloat(this._leftInput.value);
        const hi = this.options.mode === 'integer' ? parseInt(this._rightInput.value, 10) : parseFloat(this._rightInput.value);
        if(!isNaN(lo) && this.options.min <= lo && lo <= this.options.max){
            this.values = [lo, hi];
        }
        else {
            this._leftInput.value = this.options.mode === 'integer' ? Math.round (this._lo) : this._lo.toFixed(1);
        }

        // this.dispatchEvent(new CustomEvent('change', { detail: [this._lo, this._hi]}));

        let event = document.createEvent('Event');
        event.initEvent('change', false, false);
        event.detail = [this._lo, this._hi];
        this.dispatchEvent(event);
        
        event.initEvent('stop', false, false);
        event.detail = [this._lo, this._hi];
        this.dispatchEvent(event);

    }
    _handleRightInput(e){
        const lo = this.options.mode === 'integer' ? parseInt(this._leftInput.value, 10) : parseFloat(this._leftInput.value);
        const hi = this.options.mode === 'integer' ? parseInt(this._rightInput.value, 10) : parseFloat(this._rightInput.value);
        if(!isNaN(hi) && this.options.min <= hi && hi <= this.options.max){
            this.values = [lo, hi];
        }
        else {
            this._rightInput.value = this.options.mode === 'integer' ?  Math.round (this._hi) : this._hi.toFixed(1);
        }

        // this.dispatchEvent(new CustomEvent('change', { detail: [this._lo, this._hi]}));

        let event = document.createEvent('Event');
        event.initEvent('change', false, false);
        event.detail = [this._lo, this._hi];
        this.dispatchEvent(event);
        
        event.initEvent('stop', false, false);
        event.detail = [this._lo, this._hi];
        this.dispatchEvent(event);
        
    }
    _handleRange(e){
        const [lo, hi] = e.detail;
        this._leftInput.value = this.options.mode === 'integer' ? Math.round (lo) : lo.toFixed(1);
        this._rightInput.value = this.options.mode === 'integer' ?  Math.round (hi) : hi.toFixed(1);        
    }
    set values ([lo, hi]) {
        if(!isNaN(lo) && this.options.min <= lo && lo <= this.options.max && !isNaN(hi) && this.options.min <= hi && hi <= this.options.max){
            super.values = [lo, hi];
        }        
        this._leftInput.value = this.options.mode === 'integer' ? Math.round (this._lo) : this._lo.toFixed(1);
        this._rightInput.value = this.options.mode === 'integer' ?  Math.round (this._hi) : this._hi.toFixed(1);

        // this.dispatchEvent(new CustomEvent('change', { detail: [lo, hi]}));
    }
    get values () {
        return super.values;
    }
}

export default RangeWidget;